module.exports = __webpack_public_path__ + "img/16-zgdzdx.b4e8824d.png";